import { render, staticRenderFns } from "./otherDeclarationReview.vue?vue&type=template&id=68bada34&scoped=true&"
import script from "./otherDeclarationReview.vue?vue&type=script&lang=js&"
export * from "./otherDeclarationReview.vue?vue&type=script&lang=js&"
import style0 from "./otherDeclarationReview.vue?vue&type=style&index=0&id=68bada34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bada34",
  null
  
)

export default component.exports